module.exports = __webpack_public_path__ + "img/copper4.c61a09cb.gif";